import 'normalize.css/normalize.css';
import 'babel-polyfill';
import {render} from 'react-dom';
import Routes from './routes';

// Catching unhandled exceptions natively 
window.addEventListener("unhandledrejection", err => {
    throw err.detail.reason;
});

render(Routes, document.getElementById('react-root'));